// extracted by mini-css-extract-plugin
export default {"header":"dynamicSubSelectorDialog_header__Oje3b","back":"dynamicSubSelectorDialog_back__GStch","title":"dynamicSubSelectorDialog_title__k2Sv6"};